import React from 'react';
import SVG from '@newrelic/gatsby-theme-newrelic/src/components/SVG';

const DropwizardIcon = (props) => {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <defs>
        <linearGradient
          x1="49.997%"
          y1="-19.516%"
          x2="49.997%"
          y2="129.63%"
          id="a"
        >
          <stop stopColor="#0994DC" offset="0%" />
          <stop stopColor="#66CEF5" offset="35.001%" />
          <stop stopColor="#127BCA" offset="84.616%" />
          <stop stopColor="#127BCA" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="50.001%"
          y1="-19.516%"
          x2="50.001%"
          y2="129.62%"
          id="b"
        >
          <stop stopColor="#0E76BC" offset="0%" />
          <stop stopColor="#36AEE8" offset="36%" />
          <stop stopColor="#00ADEF" offset="84.616%" />
          <stop stopColor="#00ADEF" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="49.999%"
          y1="110.92%"
          x2="49.999%"
          y2="-6.214%"
          id="c"
        >
          <stop stopColor="#1C63B7" offset="0%" />
          <stop stopColor="#33BDF2" offset="50%" />
          <stop stopColor="#33BDF2" stopOpacity=".42" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="50.001%"
          y1="-19.515%"
          x2="50.001%"
          y2="129.63%"
          id="d"
        >
          <stop stopColor="#166AB8" offset="0%" />
          <stop stopColor="#36AEE8" offset="39.999%" />
          <stop stopColor="#0798DD" offset="84.616%" />
          <stop stopColor="#0798DD" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="49.999%"
          y1="-19.521%"
          x2="49.999%"
          y2="129.63%"
          id="e"
        >
          <stop stopColor="#124379" offset="0%" />
          <stop stopColor="#1487CB" offset="39%" />
          <stop stopColor="#165197" offset="78.023%" />
          <stop stopColor="#165197" offset="100%" />
        </linearGradient>
        <linearGradient x1="0%" y1="50.001%" x2="100%" y2="50.001%" id="f">
          <stop stopColor="#33BDF2" stopOpacity=".698" offset="0%" />
          <stop stopColor="#1DACD8" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="50.01%"
          y1="94.686%"
          x2="50.01%"
          y2="-3.025%"
          id="g"
        >
          <stop stopColor="#136AB4" offset="0%" />
          <stop stopColor="#59CAF5" stopOpacity=".549" offset="60%" />
          <stop stopColor="#59CAF5" stopOpacity=".235" offset="100%" />
        </linearGradient>
        <linearGradient x1="-.001%" y1="50%" x2="99.999%" y2="50%" id="h">
          <stop stopColor="#05A1E6" stopOpacity=".247" offset="0%" />
          <stop stopColor="#05A1E6" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="49.998%"
          y1="124.31%"
          x2="49.998%"
          y2="-9.421%"
          id="i"
        >
          <stop stopColor="#318ED5" offset="0%" />
          <stop stopColor="#38A7E4" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="49.999%"
          y1="91.2%"
          x2="49.999%"
          y2="-76.785%"
          id="j"
        >
          <stop stopColor="#05A1E6" offset="0%" />
          <stop stopColor="#05A1E6" stopOpacity=".549" offset="100%" />
        </linearGradient>
        <linearGradient x1="50%" y1="100.01%" x2="50%" y2=".01%" id="k">
          <stop stopColor="#1959A6" offset="0%" />
          <stop stopColor="#05A1E6" offset="50%" />
          <stop stopColor="#7EC5EA" offset="91.759%" />
          <stop stopColor="#7EC5EA" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="55.283%"
          y1="94.568%"
          x2="43.787%"
          y2="5.755%"
          id="l"
        >
          <stop stopColor="#165096" offset="0%" />
          <stop stopColor="#0D82CA" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="49.995%"
          y1="76.998%"
          x2="49.995%"
          y2="-3.299%"
          id="m"
        >
          <stop stopColor="#05A1E6" offset="0%" />
          <stop stopColor="#0495D6" offset="87.363%" />
          <stop stopColor="#0495D6" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="55.975%"
          y1="-4.161%"
          x2="43.839%"
          y2="105.84%"
          id="n"
        >
          <stop stopColor="#38A7E4" stopOpacity=".329" offset="0%" />
          <stop stopColor="#0E88D3" offset="96.153%" />
          <stop stopColor="#0E88D3" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="50.017%"
          y1="-.296%"
          x2="50.017%"
          y2="101.88%"
          id="o"
        >
          <stop stopColor="#168CD4" offset="0%" />
          <stop stopColor="#1C87CC" offset="50%" />
          <stop stopColor="#154B8D" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="16.674%"
          y1="52.666%"
          x2="87.813%"
          y2="48.803%"
          id="p"
        >
          <stop stopColor="#97D6EE" offset="0%" />
          <stop stopColor="#55C1EA" offset="70.329%" />
          <stop stopColor="#55C1EA" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="6.89%"
          y1="46.507%"
          x2="75.783%"
          y2="55.337%"
          id="q"
        >
          <stop stopColor="#7ACCEC" offset="0%" />
          <stop stopColor="#3FB7ED" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="49.997%"
          y1="6.363%"
          x2="49.997%"
          y2="127.96%"
          id="r"
        >
          <stop stopColor="#1DA7E7" offset="0%" />
          <stop stopColor="#37ABE7" stopOpacity="0" offset="100%" />
        </linearGradient>
      </defs>
      <g fillRule="nonzero" fill="none">
        <path
          d="M11.163 3.586c1.146 3.503 1.58 9.753 4.93 9.753.255 0 .513-.025.771-.074-3.045-.71-3.406-6.892-5.264-10.093-.146.132-.29.27-.437.414"
          fill="url(#a)"
          transform="translate(0 9)"
        />
        <path
          d="M11.6 3.172c1.858 3.201 2.22 9.383 5.265 10.093.239-.044.479-.11.719-.194-2.733-1.34-3.49-7.342-5.6-10.232-.127.106-.255.217-.384.333"
          fill="url(#b)"
          transform="translate(0 9)"
        />
        <path
          d="M14.277 10.268c-.254 0-.512.025-.772.074-.678.128-1.366.42-2.06.862.19.187.37.401.54.635.706-.586 1.407-1.02 2.106-1.28.262-.097.523-.17.785-.218a2.42 2.42 0 00-.599-.073"
          fill="#14559A"
        />
        <path
          d="M19.717 11.836c.28-.222.56-.468.84-.737-1.163-3.487-1.58-9.826-4.953-9.826-.242 0-.485.023-.728.068 3.073.764 3.467 7.45 4.841 10.495"
          fill="url(#c)"
          transform="translate(0 9)"
        />
        <path
          d="M14.876 10.341a2.423 2.423 0 00-.599-.073l1.327.005c-.242 0-.485.022-.728.068"
          fill="#3092C4"
        />
        <path
          d="M19.66 21.577a4.992 4.992 0 01-.381-.411 6.98 6.98 0 01-1.695.905 2.61 2.61 0 001.17.268c.63 0 1.13-.074 1.553-.278a2.949 2.949 0 01-.648-.484"
          fill="#1969BC"
        />
        <path
          d="M14.091 1.56C16.844 3 17.083 9.52 19.28 12.165c.147-.104.293-.214.439-.33-1.375-3.045-1.768-9.73-4.84-10.495-.263.05-.525.122-.787.22"
          fill="url(#d)"
          transform="translate(0 9)"
        />
        <path
          d="M11.984 2.839c2.11 2.89 2.866 8.892 5.6 10.232a6.979 6.979 0 001.694-.905C17.082 9.519 16.843 3 14.09 1.56c-.698.26-1.4.692-2.106 1.278"
          fill="url(#e)"
          transform="translate(0 9)"
        />
        <path
          d="M9.814 3.502c-.331.748-.67 1.73-1.078 3.014.813-1.145 1.623-2.13 2.428-2.93a8.802 8.802 0 00-.359-.935c-.329.252-.66.535-.991.85"
          fill="url(#f)"
          transform="translate(0 9)"
        />
        <path
          d="M11.098 11.435c-.097.07-.194.14-.293.216.129.28.247.594.358.935.146-.143.292-.282.437-.414a5.795 5.795 0 00-.502-.737"
          fill="#2B74B1"
        />
        <path
          d="M11.445 11.204c-.115.073-.23.15-.346.23.18.223.345.47.502.738.128-.116.256-.228.384-.333a5.114 5.114 0 00-.54-.635"
          fill="#125A9E"
        />
        <path
          d="M30.218 1.001c-1.556 6.004-4.808 10.825-7.533 12.04h-.005a4.33 4.33 0 01-.148.063c-.006.004-.012.005-.018.007l-.042.016c-.006.004-.012.006-.018.008-.023.008-.046.015-.068.024l-.029.01a.342.342 0 01-.033.011l-.033.011-.03.01c-.02.006-.037.01-.057.018-.009 0-.016.004-.025.006l-.04.011c-.009.004-.016.005-.026.007a.857.857 0 01-.043.012l-.052.011c.123.045.251.068.39.068 2.585 0 5.19-4.632 9.503-12.335h-1.693v.002z"
          fill="url(#g)"
          transform="translate(0 9)"
        />
        <path
          d="M8.175 1.512c.002 0 .004-.004.005-.004.002 0 .005 0 .006-.004h.003l.042-.016c.004 0 .006 0 .008-.004.004 0 .008-.004.011-.005l.045-.016h.003c.034-.01.065-.023.099-.035.004 0 .009-.004.015-.004l.042-.012c.007-.004.013-.004.02-.006l.042-.013c.006 0 .012-.004.017-.005.047-.013.094-.025.142-.036.006 0 .012-.004.02-.005a.272.272 0 01.04-.008c.007-.004.014-.004.021-.006.014-.004.027-.005.042-.008h.01l.086-.016h.017c.014-.004.027-.004.04-.007.008 0 .016-.004.023-.004.013 0 .025-.004.038-.006.007 0 .013 0 .021-.004.03-.004.061-.006.093-.008a2.872 2.872 0 00-.275-.014c-2.91 0-6.921 5.4-8.728 12.395h.348a101.402 101.402 0 001.573-2.922C3.309 5.785 5.886 2.406 8.175 1.51"
          fill="url(#h)"
          transform="translate(0 9)"
        />
        <path
          d="M9.814 12.502c.33-.316.662-.6.991-.851a4.684 4.684 0 00-.236-.457c-.266.323-.51.75-.755 1.308M10.053 10.553c.19.16.36.379.516.641.05-.06.099-.116.15-.168a2.918 2.918 0 00-.666-.473"
          fill="#0D82CA"
        />
        <path
          d="M2.044 10.74C4.698 5.624 5.955 2.387 8.175 1.51c-2.289.896-4.866 4.275-6.131 9.228"
          fill="url(#i)"
          transform="translate(0 9)"
        />
        <path
          d="M10.72 11.026c-.052.053-.101.108-.151.168.083.14.161.292.237.457.098-.075.195-.147.293-.216a3.986 3.986 0 00-.38-.409"
          fill="#127BCA"
        />
        <path
          d="M3.249 13.638c-.017.004-.033.004-.048.006h-.01c-.013 0-.028.004-.04.004h-.007c-.033.004-.066.004-.098.006h-.01c2.686-.075 3.914-1.42 4.524-3.37.463-1.48.843-2.725 1.176-3.77C7.611 8.096 6.481 9.984 5.345 12.1c-.548 1.02-1.382 1.445-2.096 1.536"
          fill="url(#j)"
          transform="translate(0 9)"
        />
        <path
          d="M3.249 13.637c.714-.091 1.548-.516 2.096-1.536C6.48 9.986 7.612 8.098 8.736 6.514c.409-1.283.746-2.266 1.078-3.014-2.241 2.133-4.49 5.68-6.565 10.136"
          fill="url(#k)"
          transform="translate(0 9)"
        />
        <path
          d="M2.044 19.74c-.475.915-.995 1.89-1.573 2.922h1.013c.134-1.024.324-2 .56-2.922"
          fill="#05A1E6"
        />
        <path
          d="M9.033 1.29c-.008 0-.014.005-.021.005-.013.004-.026.004-.038.005-.008 0-.015 0-.023.004-.014.004-.026.005-.04.007-.006 0-.012 0-.017.004l-.086.015h-.01a.34.34 0 01-.042.009c-.007.004-.014.004-.021.005-.014.004-.028.006-.041.008-.007.005-.013.005-.02.005a4.563 4.563 0 00-.142.037c-.005 0-.01.004-.016.005a2.502 2.502 0 00-.043.012c-.006.004-.013.004-.02.006a1.184 1.184 0 00-.042.013c-.005 0-.01.004-.015.004-.033.012-.065.024-.099.034l-.045.016c-.006.004-.011.005-.019.008-.014.004-.028.01-.041.015l-.014.007c-2.22.876-3.477 4.113-6.132 9.228a24.642 24.642 0 00-.56 2.921h.143c.4 0 .513-.004.974-.004h.446c.031-.004.064-.004.097-.006h.007c.013 0 .027-.004.04-.004h.01c.015 0 .032-.005.048-.006C5.326 9.186 7.576 5.64 9.816 3.507c.247-.558.49-.985.755-1.307a2.475 2.475 0 00-.516-.642s-.005 0-.005-.005c-.011-.004-.021-.01-.032-.015l-.031-.016a.338.338 0 01-.03-.014c-.014-.004-.025-.01-.037-.015l-.028-.013a1.196 1.196 0 01-.058-.024l-.026-.01a.835.835 0 01-.043-.017c-.008-.004-.016-.005-.024-.008l-.06-.02h-.006c-.023-.009-.046-.014-.07-.021-.006-.004-.01-.004-.016-.005l-.06-.017c-.005 0-.01-.004-.013-.004a2.1 2.1 0 00-.148-.032c-.005 0-.01-.004-.015-.004a.873.873 0 00-.064-.01c-.005-.004-.009-.004-.013-.004a1.703 1.703 0 00-.076-.01h-.013c-.02-.004-.04-.005-.058-.007l-.093.009"
          fill="url(#l)"
          transform="translate(0 9)"
        />
        <path
          d="M24.138 4.325c-.51 1.636-.924 2.985-1.284 4.096 1.401-1.929 2.782-4.354 4.096-7.154-1.533.482-2.351 1.584-2.812 3.058"
          fill="url(#m)"
          transform="translate(0 9)"
        />
        <path
          d="M22.898 12.94a4.405 4.405 0 01-.213.102c2.725-1.215 5.977-6.037 7.533-12.04h-.315c-3.577 6.389-4.727 10.665-7.005 11.938"
          fill="url(#n)"
          transform="translate(0 9)"
        />
        <path
          d="M21.118 21.403c.593-.724 1.076-1.954 1.736-3.982-.76 1.045-1.527 1.943-2.293 2.675 0 .004 0 .004-.004.007.167.5.35.943.56 1.3"
          fill="#079AE1"
        />
        <path
          d="M21.118 21.403a2.43 2.43 0 01-.812.658 2.297 2.297 0 00.968.274h.008c.021 0 .043 0 .066.004H21.57c.008 0 .016 0 .024-.004.016 0 .033 0 .05-.004h.024c.016 0 .035-.004.053-.006h.004c.005 0 .011-.004.016-.004.02-.004.039-.006.057-.008h.017c.02-.005.042-.007.064-.011h.01c.043-.008.085-.016.127-.027-.352-.129-.646-.433-.9-.865"
          fill="#1969BC"
        />
        <path
          d="M16.093 22.339c.255 0 .513-.025.772-.075.239-.043.479-.11.719-.193a2.615 2.615 0 001.17.268h-2.66z"
          fill="#1E5CB3"
        />
        <path
          d="M18.754 22.339c.63 0 1.129-.075 1.553-.278a2.298 2.298 0 00.967.274h.009c.02 0 .043 0 .065.004h.077-2.673.002z"
          fill="#1E5CB3"
        />
        <path
          d="M21.426 22.339h.146c.009 0 .017 0 .025-.004.016 0 .033 0 .05-.004h.024c.016 0 .035-.004.052-.006h.005c.005 0 .01-.004.016-.004.019-.004.038-.005.057-.008.006 0 .01 0 .017-.004.021-.005.043-.007.064-.01h.01c.043-.009.085-.017.128-.028.123.046.251.069.39.069l-.983.004v-.005z"
          fill="#1D60B5"
        />
        <path
          d="M20.56 20.103v-.004c-.281.268-.562.514-.841.737a9.657 9.657 0 01-.44.33c.124.147.25.285.381.41.2.195.415.358.648.484a2.424 2.424 0 00.812-.658c-.209-.356-.393-.799-.56-1.3"
          fill="#175FAB"
        />
        <path
          d="M28.904 1.001H27.317c-.086.004-.17.007-.252.013-.039.083-.079.166-.117.25-1.314 2.8-2.694 5.225-4.096 7.154-.659 2.027-1.142 3.258-1.735 3.982.253.432.548.736.9.865.01-.004.017-.004.027-.006h.005c.007 0 .013-.004.02-.004l.044-.011c.009-.004.017-.004.026-.007l.04-.01c.007-.005.016-.006.024-.008l.058-.017a.17.17 0 01.03-.01c.01-.004.022-.007.032-.012l.034-.01c.009-.005.019-.007.027-.01l.069-.025c.006 0 .012-.006.019-.007l.042-.016c.005-.004.01-.005.017-.007.049-.02.098-.04.148-.063h.005c.07-.03.142-.066.213-.102 2.278-1.273 3.429-5.55 7.005-11.938h-.999.001z"
          fill="url(#o)"
          transform="translate(0 9)"
        />
        <path
          d="M9.126 10.282c.006 0 .01 0 .017.004.013 0 .027 0 .04.005h.015l.075.01a1.58 1.58 0 00.077.015c.005 0 .01.003.016.003.049.01.1.02.147.033.005 0 .01.004.013.004l.06.017c.006 0 .01.004.016.005a1.057 1.057 0 01.075.024c.02.006.04.014.062.02.008.005.015.006.023.008.014.007.03.013.044.018.008 0 .016.006.025.009l.058.025.03.012a.252.252 0 00.034.015l.031.015.032.016c.253.124.487.29.703.492.08-.084.163-.16.25-.227a2.746 2.746 0 00-1.843-.517"
          fill="#7DCBEC"
        />
        <path
          d="M10.72 11.026c.132.123.258.26.379.409.116-.08.23-.159.346-.231a3.657 3.657 0 00-.477-.404c-.086.067-.169.142-.249.226"
          fill="#5EC5ED"
        />
        <path
          d="M9.126 1.786a2.75 2.75 0 001.842-.517c.5.393 1.103.53 1.94.53H8.851c.094 0 .185-.005.275-.013"
          fill="url(#p)"
          transform="matrix(1 0 0 -1 0 12.068)"
        />
        <path
          d="M12.908 2.204c-.838 0-1.44-.138-1.94-.531.166-.117.325-.253.477-.405.694.442 1.383.734 2.06.862.26.049.518.074.772.074h-1.369z"
          fill="url(#q)"
          transform="matrix(1 0 0 -1 0 12.472)"
        />
        <path
          d="M22.854 8.421c.36-1.11.773-2.46 1.285-4.096.461-1.475 1.277-2.577 2.81-3.058.041-.082.08-.167.119-.25-2.5.15-3.668 1.42-4.256 3.304-1.028 3.287-1.65 5.417-2.25 6.775.766-.732 1.532-1.63 2.292-2.675"
          fill="url(#r)"
          transform="translate(0 9)"
        />
      </g>
    </SVG>
  );
};

export default DropwizardIcon;
